<template>
  <mdb-container fluid>
    
    <div class="row">
      
      <div class="col-lg-4 col-md-12 mb-4"></div>
      
      <div class="col-lg-4 col-md-6 mb-4">
        
        <div class="card">
          <div class="card-body">
            

              <p class="h5 text-center mb-4">تغییر رمزعبور</p>

              <ValidationObserver v-slot="{ invalid }">
                       
                    <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                      <mdb-input
                        label="لطفا رمز عبور فعلی خودتان را وارد کنید"
                        icon="lock"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="form.OldPassword"
                        :error-messages="errors"
                        class="req v-input--is-label-active"
                        @click:append="passwordVisible = !passwordVisible"
                        :append-icon="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
                      />
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                      <mdb-input
                        label="لطفا رمز عبور جدید را وارد کنید"
                        icon="lock"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="form.NewPassword"
                        :error-messages="errors"
                        class="req v-input--is-label-active"
                        @click:append="passwordVisible = !passwordVisible"
                        :append-icon="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
                      />
                    </ValidationProvider>


                    <ValidationProvider v-slot="{ errors }" name="ConfirmPassword" rules="required">
                      <mdb-input
                        label="لطفا تکرار رمز عبور جدید را وارد کنید"
                        icon="lock"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="form.ConfirmPassword"
                        :error-messages="errors"
                        @keyup.enter="passwordEnter"
                        class="req v-input--is-label-active"
                        @click:append="passwordVisible = !passwordVisible"
                        :append-icon="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
                      />
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Captch" rules="required">
                      <div class="row">
                        <div class="col-4"></div>
                        <img alt="captcha" :src="form.CaptchaImgUrl"
                          style="margin-bottom: 4px;">
                      <a class="fas fa-refresh btn-sm" style="cursor: pointer"
                        name="dntCaptchaRefreshButton" @click="doRefresh()"></a>
                      </div>
                      <mdb-input
                        label="لطفا حاصل جمع اعداد بالا را وارد کنید"
                        labelColor="white"
                        icon="robot"
                        v-model="form.CaptchaInputText"
                        :error-messages="errors"
                        class="req v-input--is-label-active"
                      />
                      
                    </ValidationProvider>

                    <div v-show="message!==null" class="alert alert-danger" v-html="message">
                    </div>
                    <div class="text-center mt-4 black-text">                  
                      <mdb-btn  color="deep-orange" 
                        :disabled="invalid || posting" 
                        @click="confirm" 
                        :loading="posting">تغییر</mdb-btn>
                    </div>
                  </ValidationObserver>
              
          </div>
        </div>
        
      </div>
      
      <div class="col-lg-4 col-md-6 mb-4"></div>
      
    </div>

  </mdb-container>
</template>

<script>
import {
  mdbView,
  mdbMask,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbIcon,
  mdbNavbarBrand,
  mdbNavbar,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbContainer,
  mdbRow,
} from "mdbvue";

import accountApi from "@/api/accountApi";
import { actionTypes } from "@/store-types";

export default {
  name: "confirm",
  components: {
    mdbView,
    mdbMask,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbNavbarBrand,
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbContainer,
    mdbRow,
  },
  data() {
    return {
      posting: false,
      form: {
        UserId: null,
        OldPassword: null,
        NewPassword: null,
        ConfirmPassword: null,

        CaptchaInputText: null,
        CaptchaImgUrl: null,
        CaptchaId: null,
        CaptchaText: null,
        CaptchaToken: null,
      },
      message: null,
      passwordVisible: false,
    };
  },
  methods: {
    confirm() {
      this.posting = true;
      this.message = null;
    //   console.log('form',this.form);

      accountApi.changePassword(this.form).then(
        ({ data }) => {
          if (data.Status === 1) {
            this.posting = false;
            this.$router.push({name: 'UserLogin'});
          } else {
            this.doRefresh();
            this.message = data.Message;
            this.posting = false;
          }
        },
        (r) => {
            this.doRefresh();
          var message = r.response.data.errors;
          this.posting = false;
          // console.log("r", r.response.data);

         this.message ="";

          // console.log("message", message);
          if(message !== undefined){
            if(message.hasOwnProperty("OldPassword")){
              this.message +='<br>'+ message.OldPassword;
            }

            if(message.hasOwnProperty("NewPassword")){
              this.message +='<br>'+ message.NewPassword;
            }
            
            if(message.hasOwnProperty("ConfirmPassword")){
              this.message +='<br>'+ message.ConfirmPassword;
            }

          }
          
        }
      );
    },
    doRefresh(){
      const vueThis = this;
      accountApi.captcha().then(
        ({ data }) => {
        //   console.log(data.CaptchaImgUrl);
          // this.from.CaptchaInputText = data.CaptchaInputText;
          vueThis.form.CaptchaImgUrl = data.CaptchaImgUrl;
          vueThis.form.CaptchaId = data.CaptchaId;
          vueThis.form.CaptchaText = data.CaptchaTextValue;
          vueThis.form.CaptchaToken = data.CaptchaTokenValue;

        },
        (r) => {
          vueThis.posting = true;
          // console.log("r", r.response.data);
        }
      );
    },
    passwordEnter() {
      // console.log("passwordEnter");
      if (this.errors.any()) {
        return;
      }
      // console.log("passwordEnter step 2");
      this.confirm();
    },
    isNumber (evt){
        const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const keyPressed = evt.key;
        
        if (!keysAllowed.includes(keyPressed)) {
              evt.preventDefault()
        }
    }
  },
  mounted() {
    const vueThis = this;
    this.form.UserId = this.$route.params.id;
    accountApi.captcha().then(
      ({ data }) => {
        // console.log(data.CaptchaImgUrl);
        // this.from.CaptchaInputText = data.CaptchaInputText;
        vueThis.form.CaptchaImgUrl = data.CaptchaImgUrl;
        vueThis.form.CaptchaId = data.CaptchaId;
        vueThis.form.CaptchaText = data.CaptchaTextValue;
        vueThis.form.CaptchaToken = data.CaptchaTokenValue;

      },
      (r) => {
        vueThis.posting = true;
        // console.log("r", r.response.data);
      }
    );

    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        // console.log("error", this.errors);
        if (this.errors != null || typeof this.errors != "undefined") {
          return;
        }
        // console.log("no error", "undefined");
        this.confirm();
      }
    });
  },
};
</script>

<style scoped>
.md-form label {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 1rem;
    color: #757575 !important;
    cursor: text;
    transition: transform .2s ease-out, color .2s ease-out;
    transform: translateY(12px);
    transform-origin: 0% 100%;
}


</style>
